import { gql } from '@apollo/client';

// One shared fragment selecting the full AiAssistantSession shape; every query + mutation reuses it
// so the wire shape is identical everywhere. source/event/consequence arrive as enum NAMES (mapped
// to ints on commit); frequency is times/years Int (the adapter converts to an annualized float).

export const AI_ASSISTANT_SESSION_FRAGMENT = gql`
  fragment AiAssistantSessionParts on AiAssistantSession {
    uxId
    status
    selectedCycleId
    riskCycles {
      cycleId
      userInput
      createdAt
      validation {
        state
        isValid
        warningMessage
        reason
        suggestion
      }
      risk {
        name
        source
        event
        consequence
        narrative
      }
    }
    frequency {
      suggestedTimes
      suggestedYears
      narrative
      chosenTimes
      chosenYears
      industryFrequencyValues {
        dataPoint
        sourceName
        sourceQuote
        confidence
        industry
      }
    }
    impacts {
      id
      name
      description
      selected
      lowerFormula
      upperFormula
      note
      sources {
        dataPoint
        sourceName
        sourceQuote
        weight
        industry
      }
    }
  }
`;

// Fetch/refetch a session by id — the source of truth, refetched after each websocket signal.
export const AI_ASSISTANT_SESSION = gql`
  query aiAssistantSession($sessionId: String!) {
    aiAssistantSession(sessionId: $sessionId) {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;

// The caller's current in-progress session (or null) — called on open to RESUME the wizard.
export const AI_ASSISTANT_ACTIVE_SESSION = gql`
  query aiAssistantActiveSession {
    aiAssistantActiveSession {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;
